import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { CloudFortifiedAppBadge, CloudFortifiedAppBadgeSources } from '../../../CloudFortifiedAppBadge';
import { CloudSecurityParticipantBadge } from '../../../CloudSecurityParticipantBadge';
/**
 * Renders either the "Cloud Fortified" or "Cloud Security Participant" badge,
 * whichever is applicable, with preference to the former when both are applicable.
 */
const HeaderCertificationBadge = props => {
  const {
    enableCloudFortifiedAppsDiscovery
  } = useFeatureFlags();
  if (enableCloudFortifiedAppsDiscovery && props.isAppCloudFortified) {
    return /*#__PURE__*/React.createElement(CloudFortifiedAppBadge, {
      showLabel: true,
      source: CloudFortifiedAppBadgeSources.AppListing
    });
  }
  if (isBugBountyParticipant(AtlassianProductHostingType.Cloud, props.bugBountyParticipant)) {
    return /*#__PURE__*/React.createElement(CloudSecurityParticipantBadge, {
      showLabel: true
    });
  }
  return null;
};
export default HeaderCertificationBadge;